import { KendoGrid, RefreshKendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, post } from "../../Util/axios_helper";
import React, { useState } from "react";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
} from "../../Util/common";
import { useDispatch, useSelector } from "react-redux";
import { getViewFileData } from "./Feedbackslice";

export const GeneralReview = ({ type }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [error, setError] = useState({});
  const [event, setEvent] = useState({
    Id: 0,
    EventNumber: "",
    Type: "",
  });
  const { files, viewFileDataLoad } = useSelector((state) => state.feedback);

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else {
      let data = GetFormData(e);
      await post("Feedback/UpdateFeedback", data);
      RefreshKendoGrid("generalfeedback");
      $("#update-general").modal("hide");
      clearForm();
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleEditClick = async (e) => {
    setEvent({
      Id: e.Id,
      EventNumber: e.EventNumber,
      Type: e.Type,
    });

    $("#update-general").modal("show");
  };

  const handleFileClick = async (e) => {
    let id = $(e).data("id");
    let type = $(e).data("type");

    dispatch(getViewFileData({ Id: id, Type: type }));
    $("#view-files").modal("show");
  };

  const clearForm = () => {
    setEvent({
      Id: 0,
      EventNumber: "",
      Type: "",
    });
    setError({});
    $("#btn-reset").click();
  };
  return (
    <>
      <KendoGrid
      exportFileName={type + "feedbackreport"}
        name={"generalfeedback"}
        url={baseURL + "Feedback/GetFeedback?Type=" + type}
        schema={{}}
        columns={[
          {
            field: "UniqueId",
            filterable: false,
            hidden: true,
          },
          {
            field: "Id",
            filterable: false,
            hidden: true,
          },
          {
            field: "EventNumber",
            title: "Event No",
            width: 150,
          },
          {
            field: "Name",
            title: "Name",
            width: 125,
          },
          {
            field: "PhoneNumber",
            title: "Phone No",
            width: 125,
          },
          {
            field: "EmailID",
            title: "Email",
            width: 150,
          },
          {
            field: "Ratingpoint",
            title: "Stars",
            width: 65,
          },
          {
            field: "FileName",
            title: "Files",
            template: function (e) {
              return `<span><a class="viewfile" data-id="${e.Id}" data-type="${e.Type}" target='_blank' style='color: blue; font-size: 12px;  '>
                        <i class='k-icon k-i-page-portrait'></i>
                      </a>&nbsp;</span>`;
            },
            width: 60,
            hidden: type == "general" ? true : false,
          },
          {
            template: function (e) {
              if (e.IsreferUs) {
                return "Yes";
              }
              return "No";
            },
            field: "IsreferUs",
            title: "Refer Us",
            width: 150,
          },
          {
            template: function (e) {
              if (e.IsvisitAgain) {
                return "Yes";
              }
              return "No";
            },
            field: "IsvisitAgain",
            title: "Visit Again",
            width: 105,
          },
          {
            field: "ReviewDate",
            title: "Review Date",
            template: "#= kendo.toString(new Date(ReviewDate), 'MM/dd/yyyy') #",
            width: 115,
          },
          {
            field: "Type",
            title: "Type",
            template:
              "#= '<div style=\"text-transform: capitalize;\">' + Type + '</div>' #",
            width: 150,
          },
          {
            field: "ReviewComments",
            title: "Comments",
            width: 300,
          },
        ]}
        showOptions={true}
        showEdit={true}
        showDelete={false}
        onEditClick={handleEditClick}
        scrollable={true}
        width={"auto"}
        height={"60vh"}
        onDataBound={() => {
          $(".viewfile").on("click", function (e) {
            handleFileClick(this);
          });
        }}
      />
      {/* <!-- Update Formal Feedback Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update-general"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Event Number</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-update-review" onSubmit={onSubmit}>
                <input type="hidden" name="Id" value={event.Id} />
                <input type="hidden" name="Type" value={event.Type} />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Event Number<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="EventNumber"
                      defaultValue={event.EventNumber}
                      placeholder="Event Number"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("TypeName", e.target.value);
                      }}
                    />
                    {error.EventNumber && (
                      <ErrorMsg text="Event Number is required" />
                    )}
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Save"} />
                  <button
                    type="reset"
                    id="btn-reset"
                    style={{ display: "none" }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Update Formal Feedback Modal --> */}

      {/* <!-- View Files Modal --> */}
      <div
        className="modal custom-modal fade"
        id="view-files"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Files</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {!viewFileDataLoad ? (
                <Loader />
              ) : (
                <>
                  <KendoGrid
                    name={"viewfile"}
                    columns={[
                      {
                        field: "sno",
                        title: "S.No",
                        width: 50,
                      },
                      {
                        field: "FileName",
                        title: "File",
                        width: 115,
                      },
                      {
                        field: "FileName",
                        title: "Download",
                        template: function (e) {
                          if (e.FileName) {
                            var fileLinks = "";
                            fileLinks += `
                            <div style="text-align: center;">
                                <a href="${baseURL}Feedback/GetImage?path=${e.FileName}" target="_blank"
                                   style="text-align: center; font-size: 20px;color:blue;">
                                   <i class='k-icon k-i-download'></i>
                                </a>
                              </div><br>`;
                            return fileLinks;
                          } else {
                            return "";
                          }
                        },
                        width: 50,
                      },
                    ]}
                    data={files}
                    paggable={false}
                    disableExportExcel={true}
                    scrollable={false}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Files Modal --> */}
    </>
  );
};
